(() => {
  const setGalleryMedia = (root, mediaId) => {
    if (!mediaId) return;

    root.querySelectorAll('[data-fpdp-media]').forEach((slide) => {
      const active = slide.dataset.fpdpMedia === String(mediaId);
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });

    root.querySelectorAll('[data-fpdp-thumb]').forEach((thumb) => {
      const active = thumb.dataset.fpdpThumb === String(mediaId);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
  };

  const initProduct = (root) => {
    if (root.dataset.fpdpReady === 'true') return;
    root.dataset.fpdpReady = 'true';

    const variantsNode = root.querySelector('[data-fpdp-variants]');
    const variantInput = root.querySelector('[data-fpdp-variant-id]');
    const productForm = root.querySelector('product-form-component');
    const price = root.querySelector('[data-fpdp-price]');
    const cartButton = root.querySelector('[ref="addToCartButton"]');
    const cartLabel = root.querySelector('[data-fpdp-cart-label]');
    const quantityInput = root.querySelector('[data-fpdp-quantity-input]');
    const addToCart = root.querySelector('add-to-cart-component');
    const cartLabels = {
      available: root.dataset.fpdpCartAvailable || 'Toevoegen aan winkelwagen',
      soldOut: root.dataset.fpdpCartSoldOut || 'Uitverkocht',
      unavailable: root.dataset.fpdpCartUnavailable || 'Niet beschikbaar',
    };
    if (!variantsNode || !variantInput) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      console.warn('[Friandries PDP] Variantgegevens konden niet worden gelezen.', error);
      return;
    }

    const optionGroups = Array.from(root.querySelectorAll('[data-fpdp-option-index]'));

    const selectedOptions = () => optionGroups.map((group) => group.querySelector('input:checked')?.value);

    const applyVariant = () => {
      const options = selectedOptions();
      const variant = variants.find(
        (item) => item.options.length === options.length && item.options.every((option, index) => option === options[index])
      );

      if (!variant) {
        cartButton?.setAttribute('disabled', '');
        if (cartLabel) cartLabel.textContent = cartLabels.unavailable;
        return;
      }

      variantInput.value = variant.purchaseId || variant.id;
      if (productForm) {
        productForm.dataset.productId = variant.bundleProductId || productForm.dataset.productId;
        productForm.dataset.productUrl = variant.bundleProductUrl || productForm.dataset.productUrl;
      }
      if (price) price.textContent = variant.price.replace(',00', '');

      const flavorSections = document.querySelectorAll(
        '.fpdp-flavors[data-fpdp-flavor-count][data-fpdp-product-id="' + root.dataset.fpdpProductId + '"]'
      );
      const boxCount = Number(String(variant.options[0] || '').match(/\d+/)?.[0]) || 0;
      flavorSections.forEach((flavorSection) => {
        const flavorCount = Number(flavorSection.dataset.fpdpFlavorCount) || 0;
        const bonbonsPerFlavor = flavorCount && boxCount % flavorCount === 0 ? boxCount / flavorCount : 0;
        if (!bonbonsPerFlavor) return;
        flavorSection.querySelectorAll('[data-fpdp-flavor-quantity]').forEach((label) => {
          label.textContent = bonbonsPerFlavor === 1 ? '1 bonbon in deze box' : bonbonsPerFlavor + ' bonbons in deze box';
        });
      });

      if (variant.available) {
        cartButton?.removeAttribute('disabled');
        if (cartLabel) cartLabel.textContent = cartLabels.available;
      } else {
        cartButton?.setAttribute('disabled', '');
        if (cartLabel) cartLabel.textContent = cartLabels.soldOut;
      }

      if (quantityInput) {
        const minimum = Number(variant.quantityMin) || 1;
        quantityInput.min = String(minimum);
        quantityInput.step = String(Number(variant.quantityStep) || 1);
        if (variant.quantityMax === null) quantityInput.removeAttribute('max');
        else quantityInput.max = String(variant.quantityMax);
        if (Number(quantityInput.value) < minimum) quantityInput.value = String(minimum);
      }

      if (variant.featuredMediaId) {
        setGalleryMedia(root, variant.featuredMediaId);
        const activeImage = root.querySelector(`[data-fpdp-media="${variant.featuredMediaId}"] img`);
        if (addToCart && activeImage?.currentSrc) addToCart.dataset.productVariantMedia = activeImage.currentSrc;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionGroups.forEach((group) => group.addEventListener('change', applyVariant));

    root.querySelectorAll('[data-fpdp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => setGalleryMedia(root, thumb.dataset.fpdpThumb));
    });

    root.querySelector('[data-fpdp-minus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      const step = Number(quantityInput.step) || 1;
      const minimum = Number(quantityInput.min) || 1;
      quantityInput.value = String(Math.max(minimum, Number(quantityInput.value || minimum) - step));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    root.querySelector('[data-fpdp-plus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      const step = Number(quantityInput.step) || 1;
      const maximum = quantityInput.max ? Number(quantityInput.max) : Infinity;
      quantityInput.value = String(Math.min(maximum, Number(quantityInput.value || 0) + step));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const init = (scope = document) => scope.querySelectorAll('[data-fpdp-product]').forEach(initProduct);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
